import React, { useEffect } from "react";
import { useStoreActions, useStoreState } from "easy-peasy";
import useStyles from "./kitchen_view_page_styles";
import RestaurantApiService from "../../../api_service/restaurant_api_service";
import KitchenCard from "../../../components/kitchen_card/kitchen_card";
import { Button } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { Panels } from "../../../utils/constants";

export default function KitchenViewPage() {
  const classes = useStyles();
  const history = useHistory();

  const restaurant = useStoreState((state) => state.restaurant);
  const kitchenOrders = useStoreState((state) => state.kitchenOrders);
  const setCurrentView = useStoreActions((actions) => actions.setCurrentView);

  useEffect(() => {
    RestaurantApiService().getKitchenList();
    const interval = setInterval(() => {
      RestaurantApiService().getKitchenList();
    }, 10000);
    return () => clearInterval(interval);
  }, []); //eslint-disable-line

  const onCloseKitchenView = () => {
    setCurrentView(Panels.CASHIER);
    history.push("/restaurant/home");
  };

  return restaurant ? (
    <div className={classes.root}>
      <Button
        className="!fixed top-1 right-2 h-7"
        color="error"
        variant="contained"
        onClick={onCloseKitchenView}
      >
        <Close />
      </Button>
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-5">
        {kitchenOrders.map((order, index) => (
          <KitchenCard order={order} key={index} />
        ))}
      </div>
    </div>
  ) : null;
}
